
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16.906 3h.406l.313.281L24.406 10H30v16H13.156a3.019 3.019 0 01-2.938-2.375L8.562 16H4.999c-1.645 0-3-1.355-3-3s1.355-3 3-3h10.75l-.188-.75c-.203-.156-.331-.224-.625-.625-.47-.642-.938-1.633-.938-2.969C13.996 4.23 15.288 3 16.904 3zm-.312 2.094c-.421.082-.594.255-.594.563 0 .903.273 1.459.531 1.813s.438.438.438.438l.344.188.125.406.594 2.25.313 1.25H5.001c-.565 0-1 .435-1 1s.435 1 1 1h5.188l.188.781 1.781 8.438c.1.467.523.781 1 .781h9.844V11.408zM25 12v12h3V12h-3z"}})])
          )
        }
      }
    